import { compose, omit } from 'ramda';

import { redirectTo, toPostLogin } from '../../store/location/actions';
import { selectLocation } from '../../store/location/selectors';
import {
  isAuthenticatedOrProspect,
  isAuthenticated,
} from '../../store/session/selectors';
import { selectTheme } from '../../store/theme/selectors';
import { appendParams } from '../url-builders/url-utils';
import {
  loginUrl,
  returnPath as getReturnPath,
  signupUrl,
} from '../url-builders';

/**
 * When a guard function returns `true` a redirect has occurred and the thunk
 * should return early to prevent further processing.
 */

export function anonymousOnly(dispatch, getState) {
  const state = getState();

  if (!isAuthenticated(state)) return false;

  const product = selectTheme(state);

  dispatch(toPostLogin(product));

  return true;
}

export function requireAuthentication(dispatch, getState) {
  const state = getState();
  const isLoggedIn = isAuthenticated(state);

  if (isLoggedIn) return false;

  const product = selectTheme(state);
  const { pathname, query } = selectLocation(state);
  const search = new URLSearchParams(omit(['email'], query)).toString();
  const returnPath = getReturnPath({ search, pathname });
  const loginPath = loginUrl({ search });

  compose(
    dispatch,
    redirectTo,
    appendParams({ product, returnPath })
  )(loginPath);

  return true;
}

export function requireAuthOrProspectEmail(dispatch, getState) {
  const state = getState();

  if (isAuthenticatedOrProspect(state)) return false;

  const product = selectTheme(state);
  const { search, pathname } = selectLocation(state);
  const returnPath = getReturnPath({ search, pathname });
  const signupPath = signupUrl({ search });

  compose(
    dispatch,
    redirectTo,
    appendParams({ product, returnPath })
  )(signupPath);

  return true;
}
